export const buildVersion = '1.2.26030427';
export const buildTimestamp = 1772652180344;
